import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useNegotiationsStore } from "../../stores/negotiationsStore";

const NegotiationRouter = () => {
  const { negotiation_id } = useParams<{ negotiation_id: string }>();
  const navigate = useNavigate();
  const { fetchNegotiationById } = useNegotiationsStore();

  useEffect(() => {
    const loadNegotiationAndRedirect = async () => {
      if (!negotiation_id) return;

      try {
        // Fetch the specific negotiation
        const negotiation = await fetchNegotiationById(parseInt(negotiation_id));

        if (negotiation) {
          // Redirect based on status
          if (negotiation.status === "New") {
            navigate(`/negotiation-packages/${negotiation_id}/configure`, { replace: true });
          } else {
            navigate(`/negotiation-packages/${negotiation_id}/assessment`, { replace: true });
          }
        } else {
          // If negotiation not found, default to configure
          console.warn(`Negotiation with ID ${negotiation_id} not found, defaulting to configure`);
          navigate(`/negotiation-packages/${negotiation_id}/configure`, { replace: true });
        }
      } catch (error) {
        console.error('Error loading negotiation for routing:', error);
        // On error, default to configure
        navigate(`/negotiation-packages/${negotiation_id}/configure`, { replace: true });
      }
    };

    loadNegotiationAndRedirect();
  }, [negotiation_id, fetchNegotiationById, navigate]);

  // Show loading while determining route
  return (
    <div className="flex items-center justify-center h-64">
      <div className="text-center">
        <i className="pi pi-spinner pi-spin text-2xl mb-2"></i>
        <p>Loading negotiation...</p>
      </div>
    </div>
  );
};

export default NegotiationRouter;